import { theme } from 'antd';

export const useTheme = () => {
  const { token } = theme.useToken();

  // Get the theme name from the CSS variable
  const getThemeName = () => {
    const root = document.documentElement;
    const appName = getComputedStyle(root).getPropertyValue('--ant-appName').trim();
    return appName.toLowerCase();
  };

  const getHeroBackgroundSrc = () => {
    return getComputedStyle(document.documentElement).getPropertyValue('--ant-heroBackgroundSrc').trim() || undefined;
  };

  const getHeroBackgroundSrcWebp = () => {
    const val = getComputedStyle(document.documentElement).getPropertyValue('--ant-heroBackgroundSrcWebp').trim();
    return val || undefined;
  };

  const getHeroBackgroundSrcWebpMobile = () => {
    const val = getComputedStyle(document.documentElement).getPropertyValue('--ant-heroBackgroundSrcWebpMobile').trim();
    return val || undefined;
  };

  return {
    themeName: getThemeName(),
    heroBackgroundSrc: getHeroBackgroundSrc(),
    heroBackgroundSrcWebp: getHeroBackgroundSrcWebp(),
    heroBackgroundSrcWebpMobile: getHeroBackgroundSrcWebpMobile(),
  };
};